import React from "react";

import "./ResetPassword.css";
import { Form, Layout, Row, Col, Input, Button, message } from "antd";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";

import STUDENT_RESET_PASSWORD from "graphql/mutations/StudentResetPassword";
import useErrors from "hooks/useErrors";
import ErrorAlerting from "common/error_alerting";

const { Content } = Layout;

function ResetPassword() {
  const [sendResetLinkForm] = Form.useForm();

  const { t } = useTranslation("login");
  const [resetPassword] = useMutation(STUDENT_RESET_PASSWORD);
  const { errors, handleError, closeError } = useErrors();

  const handleResetPassword = async (values: any) => {
    try {
      const {
        data: {
          studentSendPasswordResetWithToken: { message: successMessage },
        },
      } = await resetPassword({
        variables: {
          ...values,
          redirectUrl: `${window.location.origin}/reset-password-confirm`,
        },
      });

      message.success(successMessage);
      sendResetLinkForm.resetFields();
    } catch (e) {
      handleError(e);
    }
  };

  return (
    <Content className="content-container login-container">
      <div style={{ maxWidth: 400 }}>
        <ErrorAlerting errors={errors} onClose={closeError} />
      </div>
      <div className="login-card">
        <div className="card-title">
          {t("Reset Your Password").toLocaleUpperCase()}
        </div>
        <Form
          name="login"
          form={sendResetLinkForm}
          onFinish={(values) => handleResetPassword(values)}
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: "Email is required." }]}
          >
            <Input
              className="input"
              type="email"
              placeholder={t("Enter email to receive instructions")}
              name="email"
              size="large"
            />
          </Form.Item>
          <Form.Item>
            <Row gutter={16}>
              <Col span={12}>
                <Button
                  className="log-in-button"
                  type="primary"
                  htmlType="submit"
                >
                  {t("Submit").toLocaleUpperCase()}
                </Button>
              </Col>
              <Col span={12}>
                <div className="login-prompt">
                  <span className="login-prompt-text">
                    {t("Not a member")}?
                  </span>
                  <a
                    href="https://flexiclasses.com"
                    target="_blank"
                    className="linked-text"
                  >
                    {t("Register here").toLocaleUpperCase()}
                  </a>
                </div>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </div>
    </Content>
  );
}

export default ResetPassword;
